/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Pdf$Params {

/**
 * NIP instytucji, do której podłączony zostanie plik.
 */
  nip: string;

/**
 * Nagłówek z zakodowaną nazwą pliku.
 */
  'Content-Disposition'?: {
};

/**
 * Kod wskazujący na formularz z którego wysłano kartę transakcji.
 */
  'X-Strona'?: string;
      body?: Blob
}

export function apiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Pdf(http: HttpClient, rootUrl: string, params: ApiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Pdf$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, apiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Pdf.PATH, 'post');
  if (params) {
    rb.path('nip', params.nip, {});
    rb.header('Content-Disposition', params['Content-Disposition'], {});
    rb.header('X-Strona', params['X-Strona'], {});
    rb.body(params.body, 'application/xml');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/pdf', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

apiWebInstytucjeNipPlikiNiezaszyfrowanyPost$Pdf.PATH = '/api/web/instytucje/{nip}/pliki/niezaszyfrowany';
